if (!window.isUndefined) {
    window.isUndefined = function(value) {
        return typeof value === "undefined"
    }
}
if (!window.isDefined) {
    window.isDefined = function(value) {
        return typeof value !== "undefined"
    }
}
if (!window.isValue) {
    window.isValue = function(value) {
        return window.isDefined(value) && value && value !== ""
    }
}
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, "includes", {
        enumerable: false,
        value: function(obj) {
            var newArr = this.filter(function(el) {
                return el == obj
            });
            return newArr.length > 0
        }
    })
}
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(callback) {
        var T, k;
        if (this == null) {
            throw new TypeError("this is null or not defined")
        }
        var O = Object(this);
        var len = O.length >>> 0;
        if (typeof callback !== "function") {
            throw new TypeError(callback + " is not a function")
        }
        if (arguments.length > 1) {
            T = arguments[1]
        }
        k = 0;
        while (k < len) {
            var kValue;
            if (k in O) {
                kValue = O[k];
                callback.call(T, kValue, k, O)
            }
            k++
        }
    }
}
if (!Shopify.originalImgUrl) {
    Shopify.originalImgUrl = function(srcUrl) {
        var srcVer = srcUrl.split("?v=")[1];
        var pos = srcUrl.split("?v=")[0].lastIndexOf(".");
        var srcExt = srcUrl.split("?v=")[0].substring(pos);
        var srcMaster = srcUrl.split("?v=")[0].substring(0, srcUrl.split("?v=")[0].substring(0, pos).lastIndexOf("_"));
        return srcMaster + srcExt + "?v=" + srcVer
    }
}
if (!Shopify.handleize) {
    Shopify.handleize = function(str) {
        return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")
    }
}
jQuery = jQuery || {};
var aCart = function() {
    var _this = {};
    _this.bind = function() {
        $(document).on("click", '[data-action="CART_PAGE_REMOVE_ITEM"]', function(event) {
            event.preventDefault();
            handleCartPageRemoveItem($(this))
        });
        $(document).on("change", 'form[action="/cart/add"] input', function(event) {
            event.preventDefault();
            var $form = $(this).closest("form");
            var formSelector = "[data-form-id=" + $form.attr("data-form-id") + "]";
            _this.updateProductFormVariantIdFromOptions(formSelector)
        });
        addEventListener("PRODUCT_FORM_VARIANT_ID_UPDATED", function(event) {
            var formSelector = event.detail.formSelector;
            renderProductFormUpdates(formSelector)
        })
    };
    _this.submitProductForm = function(formSelector, callback) {
        var $form = $(formSelector);
        var variant_id = $form.find("[name=id]").val();
        var quantity = $form.find("[name=quantity]").val() || 1;
        var params = {
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + quantity + "&id=" + variant_id,
            dataType: "json",
            success: function(line_item) {
                if (typeof callback === "function") {
                    callback(line_item)
                }
            },
            error: function(XMLHttpRequest, textStatus) {
                if (typeof callback === "function") {
                    callback()
                }
                Shopify.onError(XMLHttpRequest, textStatus)
            }
        };
        if (window.isValue(variant_id)) {
            $.ajax(params)
        }
    };
    _this.updateProductFormVariantIdFromOptions = function(formSelector, callback) {
        updateProductFormVariantIdFromOptions(formSelector, callback)
    };
    _this.removeItem = function(props) {
        removeItem(props)
    };
    _this.getVariantWithMatchingOptions = function(selectedOptions, productData) {
        return getVariantWithMatchingOptions(selectedOptions, productData)
    };
    return _this;

    function handleCartPageRemoveItem($anchorClicked) {
        var targetVariantID = 0;
        var v = parseInt($anchorClicked.data("variant_id"));
        if (v) {
            targetVariantID = v
        }
        removeItem(targetVariantID, function() {})
    }

    function removeItem(variantId, callback) {
        var params = {
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=0&id=" + variantId,
            dataType: "json",
            success: function(cart) {
                location.reload();
                if (typeof callback === "function") {
                    callback(cart)
                } else {
                    Shopify.onCartUpdate(cart)
                }
            },
            error: function(XMLHttpRequest, textStatus) {
                Shopify.onError(XMLHttpRequest, textStatus)
            }
        };
        jQuery.ajax(params)
    }

    function updateProductFormVariantIdFromOptions(formSelector) {
        var $form = $(formSelector);
        var formDataArray = $form.serializeArray();
        var product_handle = $form.data("product-handle");
        var $formSubmit = $form.find("input.add_product_submit");
        var $formOutOfStock = $form.find(".product_oos_wrapper");
        var productData = aStore.products[product_handle];
        var selectedOptions = [];
        $(".size_radios_group").removeClass("required");
        $(".title_radios_group").removeClass("required");
        var expectedOptions = productData.options;
        for (var i = 0; i < expectedOptions.length; i++) {
            var input_name = expectedOptions[i];
            var this_options_selected_value = "";
            for (var j = 0; j < formDataArray.length; j++) {
                var formInputDataEntry = formDataArray[j];
                if (formInputDataEntry.name === input_name) {
                    this_options_selected_value = formInputDataEntry.value
                }
            }
            selectedOptions.push(this_options_selected_value)
        }
        var matchingVariantId = getVariantWithMatchingOptions(selectedOptions, productData);
        jQuery("input[name=varid]").val(matchingVariantId);
        var productPriceSelector = "[data-selected-variant-price=a_" + productData.id + "]";
        var variantPrice = getVariantById(matchingVariantId).price || 0;
        var comparePrice = getVariantById(matchingVariantId).compare_at_price || 0;
        var fVariantPrice = Shopify.formatMoney(variantPrice, "${{amount}}");
        var priceHtml = "";
        if (comparePrice > variantPrice) {
            var fComparePrice = Shopify.formatMoney(comparePrice, "${{amount}}");
            priceHtml = '<span class="now">now ' + fVariantPrice + '</span> <span class="was">was <s class="compare-at-price">' + fComparePrice + "</s></span>"
        } else {
            priceHtml = fVariantPrice
        }
        if (productData.tags.includes("#finalsale")) {
            priceHtml += ' <span class="final-sale">FINAL SALE</span>'
        }
        jQuery(productPriceSelector).html(priceHtml);
        var variantOptionSelector = "[name=id] option[value=" + matchingVariantId + "]";
        var variantDisabled = $form.find(variantOptionSelector).prop("disabled");
        if (variantDisabled) {
            $formSubmit.hide();
            $formSubmit.prop("disabled", 1);
            $formOutOfStock.removeClass("hide");
            $("#BIS_trigger").attr("data-variant-id", matchingVariantId);
            return false
        }
        $formSubmit.show();
        $formSubmit.prop("disabled", false);
        $formOutOfStock.addClass("hide");
        $form.find("[name=id]").val(matchingVariantId);
        var userInputEvent = new CustomEvent("PRODUCT_FORM_VARIANT_ID_UPDATED", {
            detail: {
                formSelector: formSelector
            }
        });
        dispatchEvent(userInputEvent)
    }

    function getVariantWithMatchingOptions(selectedOptions, productData) {
        var variant_id;
        for (var i = 0; i < productData.variants.length; i++) {
            var variant = productData.variants[i];
            if (areArraysEqual(selectedOptions, variant.options) === true) {
                variant_id = variant.id
            }
        }
        return variant_id;

        function areArraysEqual(arrayA, arrayB) {
            return JSON.stringify(arrayA) === JSON.stringify(arrayB)
        }
    }

    function renderProductFormUpdates(formSelector) {}

    function getVariantById(id) {
        var variant = {};
        var productsData = aStore.products;
        var target_variant_id = id;
        var i = 0;
        var match_found = false;
        for (var prop in productsData) {
            if (match_found) {
                break
            }
            if (!productsData.hasOwnProperty(prop)) {
                continue
            }
            i++;
            var product = productsData[prop];
            for (var j = 0; j < product.variants.length; j++) {
                var _variant = product.variants[j];
                if (String(_variant.id) === String(target_variant_id)) {
                    match_found = true;
                    variant = _variant;
                    return variant
                }
            }
        }
        return variant
    }
}();
$(document).ready(function() {
    aCart.bind()
});
var aPopup = function() {
    var _this = {};
    jQuery(document).on("click", "[data-action=CLOSE_POPUP_MODAL]", function(event) {
        event.preventDefault();
        close()
    });
    jQuery(document).mouseup(function(event) {
        var $container = jQuery(".popup_frame");
        if (!$container.is(event.target) && $container.has(event.target).length === 0) {
            close()
        }
    });
    _this.openHtmlString = function(htmlString, callback) {};
    _this.openTargetElement = function(selectorString, callback) {
        var $contents_target = jQuery("#popup_contents_bucket").find(selectorString);
        var $injection_point = jQuery("#popup_modal .contents_frame");
        var $contents_clone = $contents_target.clone();
        $injection_point.html(jQuery("<div></div>").html($contents_clone));
        jQuery("body").attr("data-popup-modal-open", "T");
        if (typeof callback === "function") {
            callback()
        }
    };
    return _this;

    function close() {
        var $body = jQuery("body");
        $body.attr("data-popup-modal-open", "F");
        $body.attr("data-popup-modal-context", "")
    }
}();
window.onload = function() {
    if (/iPhone|iPad/i.test(navigator.userAgent)) {
        $(document).on("click touchstart", function(event) {
            if ($(event.target).has(".popup_frame").length) {
                $(".popup_modal").hide()
            }
        })
    }
}(function() {
    $(document).on("click", ".toggle_collection_sidebar", function(event) {
        event.preventDefault();
        var $container = $(".collection-sidebar");
        $container.toggleClass("collection-sidebar--opened collection-sidebar--collapsed")
    });
    $(document).on("click", ".left_sidebar .filter:not(.blocked) > a", function(event) {
        event.preventDefault();
        var $category_root = $(this).closest(".filter");
        var $contents = $category_root.find(".options");
        var was_open = !!$category_root.hasClass("open");
        if (was_open) {
            $category_root.addClass("blocked");
            $contents.slideUp(function() {
                $category_root.removeClass("open");
                $category_root.removeClass("blocked")
            })
        } else {
            $category_root.addClass("blocked");
            $category_root.addClass("open");
            $contents.slideDown(function() {
                $category_root.removeClass("blocked")
            })
        }
    })
}());
(function() {
    $(document).on("click", ".close_search_dropdown", function(event) {
        event.preventDefault();
        $(".header .search_dropdown_menu").removeClass("visible")
    });
    $(document).on("click", ".open_search_dropdown", function(event) {
        event.preventDefault();
        $(".header .search_dropdown_menu").addClass("visible");
        $('.header .search_dropdown_menu.visible input[name="q"]').focus()
    })
})();
(function() {
    $(document).on("click", ".mobile_search_button .close_search_dropdown", function(event) {
        event.preventDefault();
        $(".header .search_dropdown_menu").removeClass("visible");
        $(".mobile_header .mobile_search_button .close_search_dropdown").css("display", "none");
        $(".mobile_header .mobile_search_button .open_search_dropdown").css("display", "block")
    });
    $(document).on("click", ".mobile_search_button .open_search_dropdown", function(event) {
        event.preventDefault();
        $(".header .search_dropdown_menu").addClass("visible");
        $('.header .search_dropdown_menu.visible input[name="q"]').focus();
        $(".mobile_header .mobile_search_button > .close_search_dropdown").css("display", "block");
        $(".mobile_header .mobile_search_button .open_search_dropdown").css("display", "none")
    })
})();
(function() {
    $(document).on("click", "[data-action=TOGGLE_MOBILE_NAV]", function(event) {
        event.preventDefault();
        var $body = $("body");
        var oldData = $body.data("mobile-nav-open");
        var mobileNavWasOpen = oldData === "T";
        var newData = mobileNavWasOpen ? "F" : "T";
        var mobileSearch = $body.find(".search_dropdown_menu_mobile");
        $body.attr("data-mobile-nav-open", newData);
        $body.data("mobile-nav-open", newData);
        if (newData === "T") {
            $(".hamburger-open").hide();
            $(".hamburger-close").show();
            var pTop = $("#shopify-section-header .master_overlay").css("top");
            mobileSearch.removeClass("visible")
        } else {
            $(".hamburger-close").hide();
            $(".hamburger-open").show();
            mobileSearch.addClass("visible")
        }
        $(document).on("click touchend", ".mobile_navigation_menu ul[data-depth=1] li .h1 a, .mobile_navigation_menu ul[data-depth=2] li .h2 a, .mobile_navigation_menu ul[data-depth=3] li .h3 a, .mobile_navigation_menu ul[data-depth=4] li .h3 a", function(event) {
            var $button = $(this);
            var $parent_li = $button.closest("li");
            if ($parent_li.find("ul").length > 0) {
                event.preventDefault()
            }
        })
    });
    $(".master_overlay").on("click touchend", function(event) {
        var $body = $("body");
        var mobileSearch = $body.find(".search_dropdown_menu_mobile");
        if (event.target) {
            event.preventDefault();
            $body.attr("data-mobile-nav-open", "F");
            $body.data("mobile-nav-open", "F");
            $(".hamburger-close").hide();
            $(".hamburger-open").show();
            mobileSearch.addClass("visible")
        }
    });
    $(document).ready(function() {
        $(document).on("touchmove", ".mobile_navigation_menu", $.debounce(50, function(event) {
            $(event.currentTarget).data("touch-scroll", "T")
        }));
        $(document).on("click touchend", ".mobile_navigation_menu .line_wrap", $.debounce(125, function(event) {
            var $mobileMenu = $(".mobile_navigation_menu");
            var touchScroll = $mobileMenu.data("touch-scroll");
            $mobileMenu.data("touch-scroll", "F");
            var $button = $(this);
            var $parent_li = $button.closest("li");
            if ($parent_li.find("ul").length === 0) {
                return true
            }
            event.preventDefault();
            if (touchScroll === "T") {
                return true
            }
            var oldData = $parent_li.data("expand");
            var sublistWasOpen = oldData === "T";
            var newData = sublistWasOpen ? "F" : "T";
            $parent_li.attr("data-expand", newData);
            $parent_li.data("expand", newData)
        }))
    })
})();
(function() {
    $(document).on("click", "[data-action=USER_ADD_TO_CART_CLICK]", function(event) {
        event.preventDefault();
        var $form = $(this).closest("form");
        var form_id = $form.data("form-id");
        var productFormSelector = "[data-form-id=" + form_id + "]";
        var variant_id = $form.find("[name=id]").val();
        if (window.isValue(variant_id)) {
            aPopup.openTargetElement("[data-popup-id=ADD_TO_CART_CONFIRM]");
            aCart.submitProductForm(productFormSelector, function() {
              
                //custom code injected for round up product on ATC behavior on PDP -REDDRESSSA-1127
                              async function doCartAjax(){
                                 var orgCount = $('.mobile-header-grid__item .cartPage.cart_summary_icon span').text();
                                
                                    var flagged = 0;
                                    var res = await fetch('/cart.js');
                                    var prodData = await res.json();
                                   
                                    var totalItemCount = parseInt(prodData.item_count);
                                    var items = prodData.items;
                                    var i = 0;
                                    $.each(items,function()
                                           {
                                            console.log(items[i].id);
                                             if(items[i].id == '42818686025917')
                                             {
                                               flagged = 1;
                                                var Qaunt = parseInt(items[i].quantity);
                                                var finalItemQuant = totalItemCount - Qaunt;
                        
                                              $('.cart_button').html(' <a class="cart_summary_icon" href="/cart"><img width="28" src="//www.reddress.com/cdn/shop/t/318/assets/cart-icon.png?v=25035758705534308611683733074"><span>' + finalItemQuant + '</span></a>');
                                               $('.mobileCartIcon').html(' <a class="cart_summary_icon" href="/cart"><img width="28" src="//www.reddress.com/cdn/shop/t/318/assets/cart-icon.png?v=25035758705534308611683733074"><span>' + finalItemQuant + '</span></a>');
                                                return false;
                                             }
                                            i++;
                                           });
                                      if(flagged == 0)
                                      {
                                        $('.cart_button').html(' <a class="cart_summary_icon" href="/cart"><img width="28" src="//www.reddress.com/cdn/shop/t/318/assets/cart-icon.png?v=25035758705534308611683733074"><span>' + totalItemCount + '</span></a>');
                                       $('.mobileCartIcon').html(' <a class="cart_summary_icon" href="/cart"><img width="28" src="//www.reddress.com/cdn/shop/t/318/assets/cart-icon.png?v=25035758705534308611683733074"><span>' + totalItemCount + '</span></a>');
                                      }
                                         
                              }
                                doCartAjax();
               //custom code injected for round up product -REDDRESSSA-1127
              
                $("#popup_modal p.msg").html("Item Added!")
            })
        } else {
            $(".size_radios_group").addClass("required");
            $(".title_radios_group").addClass("required")
        }
    });
    $(document).on("click", "[data-action=OPEN_PRODUCT_SIZE_CHART_POPUP]", function(event) {
        event.preventDefault();
        aPopup.openTargetElement("[data-popup-id=PRODUCT_SIZE_CHART]")
    });
    $(document).on("click", "[data-userEvent=PRODUCT_PAGE_DESCRIPTION_TAB_CLICK]", function(event) {
        event.preventDefault();
        var $tabs = $(".info_tabs_widget");
        var new_tab_index = $(this).index() + 1;
      var test = $(this).index();
        $tabs.data("currentTab", new_tab_index);
      console.log(test);
        $tabs.attr("data-currentTab", new_tab_index)
    });

    // Update Yotpo Write Review message
    document.addEventListener('animationstart', function(event) {
        if (event.animationName == 'nodeInserted') {
            var ratingContent = jQuery('.yotpo a.text-m').text();
            if (ratingContent.includes('Write')) {
                jQuery('.yotpo a.text-m').text('Be the first to write a review');
                jQuery('.yotpo .write-review-button span.yotpo-icon-button-text').text('Be the first to write a review');
            }
        }
    }, true);

    (function() {
        var vid = $(".hero__item").children("video").get(0);
        $(vid).attr("controlsList", "nodownload");
        $(vid).bind("contextmenu", function() {
            return false
        });
        $(vid).attr("disablePictureInPicture", "true");

        function playPauseVideo(slick, control) {
            var currentSlide, slideType, startTime, player, video;
            currentSlide = slick.find(".slick-current");
            slideType = currentSlide.attr("data-type");
            player = currentSlide.find("iframe").get(0);
            startTime = currentSlide.data("video-start");
            if (slideType === "video") {
                video = currentSlide.children("video").get(0);
                if (video != null) {
                    if (control === "play") {
                        video.play();
                        video.muted = true
                    } else {
                        video.pause()
                    }
                }
            }
        }
        $(".left_column.gallery .hero").on("init", function(slick) {
            slick = $(slick.currentTarget);
            setTimeout(function() {
                playPauseVideo(slick, "play")
            }, 1e3)
        });
        $(".left_column.gallery .hero").on("beforeChange", function(event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, "pause")
        });
        $(".left_column.gallery .hero").on("afterChange", function(event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, "play")
        });
        $(".left_column.gallery .hero").slick({
            arrows: false,
            dots: false,
            fade: true,
            responsive: [{
                breakpoint: 993,
                settings: {
                    dots: true,
                    fade: false,
                    adaptiveHeight: true
                }
            }]
        });
        $(".left_column.gallery .thumbs").slick({
            arrows: true,
            dots: false,
            fade: false,
            slidesToShow: 5,
            vertical: true
        });
        $(document).on("click", ".left_column.gallery .thumbs a", function(event) {
            event.preventDefault();
            var target_index = $(this).data("slick-index");
            $(".left_column.gallery .hero").slick("slickGoTo", target_index)
        })
    })()
})();
(function(SocialSharing, $) {
    var injectPinterestScript = function() {
        var d = document;
        var f = d.getElementsByTagName("SCRIPT")[0],
            p = d.createElement("SCRIPT");
        p.type = "text/javascript";
        p.async = true;
        p.src = "//assets.pinterest.com/js/pinit.js";
        f.parentNode.insertBefore(p, f)
    };
    var bindUIActions = function() {
        $(document).on("click", ".social-sharing-icon", function(e) {
            e.preventDefault();
            switch ($(this).data("network")) {
                case "facebook":
                    window.open("http://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href), "Facebook", "width=600, height=400, scrollbars=no");
                    break;
                case "twitter":
                    window.open("http://www.twitter.com/intent/tweet?url=" + encodeURIComponent(window.location.href), "Tweet", "width=600, height=450, scrollbars=no");
                    break;
                case "pinterest":
                    var uri = window.location.href;
                    var url = encodeURIComponent(uri);
                    var isProduct = uri.search("/products/");
                    var isTheMvmtBlog = uri.search("/the-mvmt/");
                    if (window.location.pathname === "/blogs/news/articles") {
                        var imgURL = encodeURIComponent($("#destination-1 img").attr("src"));
                        var description = $(".article-header-content p").text()
                    } else {
                        if (isProduct != -1) {
                            var imgURL = encodeURIComponent($(".product-slider").find("img").first().attr("src"));
                            var description = "MVMT " + $(".prod-series").text() + $(".prod-name").text()
                        } else {
                            if (isTheMvmtBlog != -1) {
                                var $allSections = $("main").find("section");
                                var firstBackgroundImg = null;
                                for (var i = 0; i < $allSections.length; i++) {
                                    if ($($allSections[i]).css("background-image") != "none") {
                                        firstBackgroundImg = $($allSections[i]).css("background-image").replace("url(", "").replace(")", "").replace(/\"/gi, "");
                                        break
                                    }
                                }
                                if (firstBackgroundImg === null) {
                                    var $allDivs = $("main").find("div");
                                    for (var i = 0; i < $allDivs.length; i++) {
                                        if ($($allDivs[i]).css("background-image") != "none") {
                                            firstBackgroundImg = $($allDivs[i]).css("background-image").replace("url(", "").replace(")", "").replace(/\"/gi, "");
                                            break
                                        }
                                    }
                                }
                                if (firstBackgroundImg === null) {
                                    firstBackgroundImg = $("main").find("img").first().attr("src");
                                    firstBackgroundImg = firstBackgroundImg.replace("url(", "").replace(")", "").replace(/\"/gi, "")
                                }
                                var imgURL = encodeURIComponent(firstBackgroundImg);
                                var uriBreakdown = uri.split("/");
                                var lastIndex = uriBreakdown.length - 1;
                                var title = uriBreakdown[lastIndex];
                                var description = title.charAt(0).toUpperCase() + title.slice(1);
                                description = "MVMT - " + description.replace(/-/g, " ")
                            } else {
                                var imgURL = encodeURIComponent($(".product-photo-thumb.slick-active img").attr("src"));
                                var description = $(".product-description").text()
                            }
                        }
                    }
                    window.open("http://pinterest.com/pin/create/link/?url=" + url + "&media=" + imgURL + "&description=" + description, "Pinterest", "width=600, height=600, scrollbars=no");
                    break;
                case "google-plus":
                    window.open("https://plus.google.com/share?url=" + encodeURIComponent(window.location.href), "GooglePlus", "width=680, height=450, scrollbars=no");
                    break
            }
        })
    };
    SocialSharing.init = function() {
        bindUIActions();
        injectPinterestScript()
    }
})(window.SocialSharing = window.SocialSharing || {}, jQuery);
SocialSharing.init();